export default {"src":"/_next/static/media/entry-door-single.f1b90f3b.svg","height":1000,"width":1000};